import React from "react";
import {
  Row,
  Col,
  Form,
  Card,
  Space,
  Typography,
  Alert,
  Radio,
  Tag,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import { canSelectGlobal } from "../useEvaluationWizard";

const { Title, Text, Paragraph } = Typography;

export function EvaluationWizardStep4Share({ role }) {
  const { t } = useTranslation("evaluations");
  const globalAllowed = canSelectGlobal(role);

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={16}>
          <Title level={5} style={{ marginTop: 0 }}>
            {t("asistente.paso4.titulo")}
          </Title>

          <Alert
            type="warning"
            showIcon
            message={t("asistente.paso4.avisoTitulo")}
            description={t("asistente.paso4.avisoDetalle")}
            style={{ marginBottom: 12 }}
          />

          <Form.Item
            name="visibility"
            rules={[
              {
                required: true,
                message: t("asistente.validacion.visibilidad"),
              },
            ]}
          >
            <Radio.Group className="revi-eval-wizard__radioCardsGroup">
              <Radio value="private" className="revi-eval-wizard__radioCard">
                <Card
                  variant="outlined"
                  className="revi-eval-wizard__visibilityCard"
                >
                  <Space orientation="vertical" size={4}>
                    <Space size={8}>
                      <Tag>{t("visibilidad.privada")}</Tag>
                      <Text strong>{t("asistente.paso4.privada.titulo")}</Text>
                    </Space>
                    <Text type="secondary">
                      {t("asistente.paso4.privada.detalle")}
                    </Text>
                  </Space>
                </Card>
              </Radio>

              <Radio value="public" className="revi-eval-wizard__radioCard">
                <Card
                  variant="outlined"
                  className="revi-eval-wizard__visibilityCard"
                >
                  <Space orientation="vertical" size={4}>
                    <Space size={8}>
                      <Tag color="blue">{t("visibilidad.institucion")}</Tag>
                      <Text strong>{t("asistente.paso4.publica.titulo")}</Text>
                    </Space>
                    <Text type="secondary">
                      {t("asistente.paso4.publica.detalle")}
                    </Text>
                  </Space>
                </Card>
              </Radio>

              <Tooltip
                title={
                  globalAllowed
                    ? t("asistente.paso4.global.tooltipPermitido")
                    : t("asistente.paso4.global.tooltipBloqueado")
                }
              >
                <Radio
                  value="global"
                  className="revi-eval-wizard__radioCard"
                  disabled={!globalAllowed}
                >
                  <Card
                    variant="outlined"
                    className={`revi-eval-wizard__visibilityCard ${!globalAllowed ? "is-disabled" : ""}`}
                  >
                    <Space orientation="vertical" size={4}>
                      <Space size={8}>
                        <Tag color="purple">{t("visibilidad.global")}</Tag>
                        <Text strong>{t("asistente.paso4.global.titulo")}</Text>
                      </Space>
                      <Text type="secondary">
                        {t("asistente.paso4.global.detalle")}
                      </Text>
                    </Space>
                  </Card>
                </Radio>
              </Tooltip>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24} lg={8}>
          <Card
            className="revi-eval-wizard__previewCard"
            variant="outlined"
            size="small"
            title={t("asistente.paso4.recomendacionTitulo")}
          >
            <Paragraph style={{ marginBottom: 0 }} type="secondary">
              {t("asistente.paso4.recomendacion")}
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
